"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealAdFormatsToJSON = exports.DealAdFormatsFromJSONTyped = exports.DealAdFormatsFromJSON = exports.DealAdFormats = void 0;
/**
 * Valid formats to which a Deal may be applied.
 * @export
 */
exports.DealAdFormats = {
    Audio: 'AUDIO',
    Image: 'IMAGE',
    Video: 'VIDEO'
};
function DealAdFormatsFromJSON(json) {
    return DealAdFormatsFromJSONTyped(json, false);
}
exports.DealAdFormatsFromJSON = DealAdFormatsFromJSON;
function DealAdFormatsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DealAdFormatsFromJSONTyped = DealAdFormatsFromJSONTyped;
function DealAdFormatsToJSON(value) {
    return value;
}
exports.DealAdFormatsToJSON = DealAdFormatsToJSON;
